import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { ImpactDataItem } from '../modules/widget/services/chart-report/chart-report-impact/chart-report-impact';

@Pipe({
  name: 'impactTooltip',
  standalone: false,
})
export class ImpactTooltipPipe implements PipeTransform {
  transform(value: ImpactDataItem) {
    return `${value.labelDisplay}\n${translate('widgets.charting.tooltip.count-part-material', {
      count: value.documentCount,
    })}`;
  }
}
